export default __webpack_public_path__ + "locales/sl/ChangePasswordDialog.json?hash=ad2743c76818fa78c50a0f76eb482e60";